<div class="pia-validation-PlanAction">
  <div class="pia-entryContentBlock-content">
    <!-- Action plan graph -->
    <div class="pia-entryContentBlock-content pia-actionPlanGraphBlock">
      <h2>{{ "action_plan.title" | translate }}</h2>
      <div class="row">
        <div class="medium-6 columns pia-actionPlanGraphBlock-left">
          <h3>{{ "action_plan.principles" | translate }}</h3>
          @for (r of actionPlanService.results; track r) {
          <div class="pia-actionPlanGraphBlock-item">
            <span class="pia-list">{{ r.short_title | translate }}</span>
            <span
              class="pia-box"
              [ngClass]="{
                'pia-blue': r.status === 2,
                'pia-red': r.status === 1
              }"
            ></span>
            <span
              class="pia-box"
              [ngClass]="{
                'pia-green': r.status === 3,
                'pia-red': r.status === 1
              }"
            ></span>
          </div>
          }
        </div>
        <div class="medium-6 columns pia-actionPlanGraphBlock-right">
          <h3>{{ "action_plan.measures" | translate }}</h3>
          <div class="pia-actionPlanGraphBlock-right-measures">
            @if (actionPlanService.measures) {
            <div class="pia-actionPlanGraphBlock-right-measures-scroll">
              @for (measure of actionPlanService.measures; track measure) {
              <div class="pia-actionPlanGraphBlock-item">
                <span
                  class="pia-box"
                  [ngClass]="{
                    'pia-blue': measure.status === 2,
                    'pia-red': measure.status === 1
                  }"
                ></span>
                <span
                  class="pia-box"
                  [ngClass]="{
                    'pia-green': measure.status === 3,
                    'pia-red': measure.status === 1
                  }"
                ></span>
                <span class="pia-list">{{ measure.name }}</span>
              </div>
              }
            </div>
            }
          </div>
          <h3>{{ "action_plan.risks" | translate }}</h3>
          <div class="pia-actionPlanGraphBlock-item">
            <span
              class="pia-box"
              [ngClass]="{
                'pia-blue':
                  actionPlanService.risks['3.2'] &&
                  actionPlanService.risks['3.2']['status'] === 2,
                'pia-red':
                  actionPlanService.risks['3.2'] &&
                  actionPlanService.risks['3.2']['status'] === 1
              }"
            ></span>
            <span
              class="pia-box"
              [ngClass]="{
                'pia-green':
                  actionPlanService.risks['3.2'] &&
                  actionPlanService.risks['3.2']['status'] === 3,
                'pia-red':
                  actionPlanService.risks['3.2'] &&
                  actionPlanService.risks['3.2']['status'] === 1
              }"
            ></span>
            <span class="pia-list">{{ "action_plan.risk1" | translate }}</span>
          </div>
          <div class="pia-actionPlanGraphBlock-item">
            <span
              class="pia-box"
              [ngClass]="{
                'pia-blue':
                  actionPlanService.risks['3.3'] &&
                  actionPlanService.risks['3.3']['status'] === 2,
                'pia-red':
                  actionPlanService.risks['3.3'] &&
                  actionPlanService.risks['3.3']['status'] === 1
              }"
            ></span>
            <span
              class="pia-box"
              [ngClass]="{
                'pia-green':
                  actionPlanService.risks['3.3'] &&
                  actionPlanService.risks['3.3']['status'] === 3,
                'pia-red':
                  actionPlanService.risks['3.3'] &&
                  actionPlanService.risks['3.3']['status'] === 1
              }"
            ></span>
            <span class="pia-list">{{ "action_plan.risk2" | translate }}</span>
          </div>
          <div class="pia-actionPlanGraphBlock-item">
            <span
              class="pia-box"
              [ngClass]="{
                'pia-blue':
                  actionPlanService.risks['3.4'] &&
                  actionPlanService.risks['3.4']['status'] === 2,
                'pia-red':
                  actionPlanService.risks['3.4'] &&
                  actionPlanService.risks['3.4']['status'] === 1
              }"
            ></span>
            <span
              class="pia-box"
              [ngClass]="{
                'pia-green':
                  actionPlanService.risks['3.4'] &&
                  actionPlanService.risks['3.4']['status'] === 3,
                'pia-red':
                  actionPlanService.risks['3.4'] &&
                  actionPlanService.risks['3.4']['status'] === 1
              }"
            ></span>
            <span class="pia-list">{{ "action_plan.risk3" | translate }}</span>
          </div>
        </div>
        <div class="pia-legend">
          <p>{{ "action_plan.improvable_measures" | translate }}</p>
          <p>{{ "action_plan.acceptable_measures" | translate }}</p>
        </div>
      </div>
    </div>

    <!-- Principles action plans -->
    <div class="pia-entryContentBlock-content-fundamental">
      <h2>{{ "action_plan.principles" | translate }}</h2>
      @if ( !actionPlanService.principlesActionPlanReady) {
      <div>
        <div class="pia-entryContentBlock-content-details-blocks">
          <div class="pia-details-blocks-content">
            <div>{{ "action_plan.no_action_plan" | translate }}</div>
          </div>
        </div>
      </div>
      } @else { @for (data of actionPlanService.results; track data) {
      <app-action-plan-implementation
        [pia]="pia"
        [data]="data"
      ></app-action-plan-implementation>
      } }
    </div>
    <!-- Measures action plans -->
    <div class="pia-entryContentBlock-content-measures">
      <h2>{{ "action_plan.measures" | translate }}</h2>
      @if ( !actionPlanService.measuresActionPlanReady) {
      <div>
        <div class="pia-entryContentBlock-content-details-blocks">
          <div class="pia-details-blocks-content">
            <div>{{ "action_plan.no_action_plan" | translate }}</div>
          </div>
        </div>
      </div>
      } @else { @for (data of actionPlanService.measures; track data) {
      <app-action-plan-implementation
        [pia]="pia"
        [data]="data"
      ></app-action-plan-implementation>
      } }
    </div>
    <!-- Risks action plans -->
    <div class="pia-entryContentBlock-content-risks">
      <h2>{{ "action_plan.risks" | translate }}</h2>
      @if ( !actionPlanService.risksActionPlan32Ready &&
      !actionPlanService.risksActionPlan33Ready &&
      !actionPlanService.risksActionPlan34Ready) {
      <div>
        <div class="pia-entryContentBlock-content-details-blocks">
          <div class="pia-details-blocks-content">
            <div>{{ "action_plan.no_action_plan" | translate }}</div>
          </div>
        </div>
      </div>
      } @else { @if (actionPlanService.risks['3.2']) {
      <div>
        <app-action-plan-implementation
          [pia]="pia"
          [data]="actionPlanService.risks['3.2']"
        ></app-action-plan-implementation>
      </div>
      } @if (actionPlanService.risks['3.3']) {
      <div>
        <app-action-plan-implementation
          [pia]="pia"
          [data]="actionPlanService.risks['3.3']"
        ></app-action-plan-implementation>
      </div>
      } @if (actionPlanService.risks['3.4']) {
      <div>
        <app-action-plan-implementation
          [pia]="pia"
          [data]="actionPlanService.risks['3.4']"
        ></app-action-plan-implementation>
      </div>
      } }
    </div>
  </div>
</div>
